



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { CheckIcon, MailIcon, PlusIcon, XIcon } from 'vue-feather-icons';
import { UserModel, UserStatus } from 'admiral-core';
import { AuthApi } from '@/services/AuthApi';

@Component({
  components: {
    PlusIcon,
    CheckIcon,
    XIcon,
    MailIcon,
  },
})
export default class ResendCodeLink extends Vue {
  @Prop({ type: Object, required: true })
  user!: UserModel;

  isLoading = false;
  sent = false;

  async ok() {
    if (!this.user.email) {
      return;
    }

    try {
      this.isLoading = true;
      if (this.user.status === UserStatus.PENDING) {
        await AuthApi.sendConfirmationReset({ email: this.user.email });
      } else if (this.user.status === UserStatus.ACTIVE) {
        await AuthApi.sendPasswordReset({ email: this.user.email });
      }
      this.sent = true;
    } catch (e) {
      console.log(e);
    } finally {
      this.isLoading = false;
    }
  }

  get label() {
    return this.user.status === UserStatus.PENDING
      ? 'Willkommens-Email erneut zusenden'
      : 'Passwort zurücksetzen E-Mail zusenden';
  }
}
